import {get} from "../utils";

export default host => ({
  get: () => get(`${host}/metrics`)
    .then(res => res.json())
    .then(res => res.data)

});
